import { parse, format, add } from 'date-fns';

export const dateParser = (dates = [], group) => {
  try {
    switch (group) {
      case 'Q':
        return dates.map((date) => {
          const [year, quarter] = date.split('-Q');
          return `Q${parseInt(quarter)} ${year}`;
        });

      case 'M':
        return dates.map((date) => {
          const [year, month] = date.split('-');
          const monthStartDate = parse(month, 'MM', new Date(`04-01-${year}`));
          return format(monthStartDate, 'MMM yyyy');
        });

      case 'W':
        return dates.map((date) => {
          const [year, week] = date.split('-W');
          const weekStartDate = parse(week, 'II', new Date(`04-01-${year}`), {
            weekStartsOn: 1,
          });

          return `${format(weekStartDate, 'dd MMM')} -
            ${format(
              add(weekStartDate, {
                days: 6,
              }),
              'dd MMM'
            )}
          `;
        });

      case 'D':
        return dates.map((date) => {
          return format(new Date(date), 'd MMM');
        });

      default:
        return dates;
    }
  } catch (error) {
    return dates;
  }
};
